/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Reporting
 * API for Vault Reporting
 *
 * The version of the OpenAPI document: 2025-05-05
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.ts';
/**
 * 
 * @export
 * @interface VaultReporting20250505SecretsInventoryRow
 */
export interface VaultReporting20250505SecretsInventoryRow {
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretName?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretType?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    namespace?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    mountPath?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    mountAccessor?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    pluginName?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    pluginType?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    pluginVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    versionCount?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    versionCurrent?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    versionOldest?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    createdById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    configLastModifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    configLastModifiedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    configLastAccessedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    configLastAccessedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    configDeletedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    configDeletedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretLastModifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretLastModifiedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretLastAccessedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretLastAccessedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretDeletedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretDeletedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretUndeletedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretUndeletedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretDestroyedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    secretDestroyedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    nextRotationAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VaultReporting20250505SecretsInventoryRow
     */
    ttl?: string;
}

/**
 * Check if a given object implements the VaultReporting20250505SecretsInventoryRow interface.
 */
export function instanceOfVaultReporting20250505SecretsInventoryRow(value: object): value is VaultReporting20250505SecretsInventoryRow {
    return true;
}

export function VaultReporting20250505SecretsInventoryRowFromJSON(json: any): VaultReporting20250505SecretsInventoryRow {
    return VaultReporting20250505SecretsInventoryRowFromJSONTyped(json, false);
}

export function VaultReporting20250505SecretsInventoryRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaultReporting20250505SecretsInventoryRow {
    if (json == null) {
        return json;
    }
    return {
        
        'secretName': json['secret_name'] == null ? undefined : json['secret_name'],
        'secretType': json['secret_type'] == null ? undefined : json['secret_type'],
        'namespace': json['namespace'] == null ? undefined : json['namespace'],
        'mountPath': json['mount_path'] == null ? undefined : json['mount_path'],
        'mountAccessor': json['mount_accessor'] == null ? undefined : json['mount_accessor'],
        'pluginName': json['plugin_name'] == null ? undefined : json['plugin_name'],
        'pluginType': json['plugin_type'] == null ? undefined : json['plugin_type'],
        'pluginVersion': json['plugin_version'] == null ? undefined : json['plugin_version'],
        'versionCount': json['version_count'] == null ? undefined : json['version_count'],
        'versionCurrent': json['version_current'] == null ? undefined : json['version_current'],
        'versionOldest': json['version_oldest'] == null ? undefined : json['version_oldest'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'createdById': json['created_by_id'] == null ? undefined : json['created_by_id'],
        'configLastModifiedAt': json['config_last_modified_at'] == null ? undefined : (new Date(json['config_last_modified_at'])),
        'configLastModifiedById': json['config_last_modified_by_id'] == null ? undefined : json['config_last_modified_by_id'],
        'configLastAccessedAt': json['config_last_accessed_at'] == null ? undefined : (new Date(json['config_last_accessed_at'])),
        'configLastAccessedById': json['config_last_accessed_by_id'] == null ? undefined : json['config_last_accessed_by_id'],
        'configDeletedAt': json['config_deleted_at'] == null ? undefined : (new Date(json['config_deleted_at'])),
        'configDeletedById': json['config_deleted_by_id'] == null ? undefined : json['config_deleted_by_id'],
        'secretLastModifiedAt': json['secret_last_modified_at'] == null ? undefined : (new Date(json['secret_last_modified_at'])),
        'secretLastModifiedById': json['secret_last_modified_by_id'] == null ? undefined : json['secret_last_modified_by_id'],
        'secretLastAccessedAt': json['secret_last_accessed_at'] == null ? undefined : (new Date(json['secret_last_accessed_at'])),
        'secretLastAccessedById': json['secret_last_accessed_by_id'] == null ? undefined : json['secret_last_accessed_by_id'],
        'secretDeletedAt': json['secret_deleted_at'] == null ? undefined : (new Date(json['secret_deleted_at'])),
        'secretDeletedById': json['secret_deleted_by_id'] == null ? undefined : json['secret_deleted_by_id'],
        'secretUndeletedAt': json['secret_undeleted_at'] == null ? undefined : (new Date(json['secret_undeleted_at'])),
        'secretUndeletedById': json['secret_undeleted_by_id'] == null ? undefined : json['secret_undeleted_by_id'],
        'secretDestroyedAt': json['secret_destroyed_at'] == null ? undefined : (new Date(json['secret_destroyed_at'])),
        'secretDestroyedById': json['secret_destroyed_by_id'] == null ? undefined : json['secret_destroyed_by_id'],
        'nextRotationAt': json['next_rotation_at'] == null ? undefined : (new Date(json['next_rotation_at'])),
        'ttl': json['ttl'] == null ? undefined : json['ttl'],
    };
}

export function VaultReporting20250505SecretsInventoryRowToJSON(json: any): VaultReporting20250505SecretsInventoryRow {
    return VaultReporting20250505SecretsInventoryRowToJSONTyped(json, false);
}

export function VaultReporting20250505SecretsInventoryRowToJSONTyped(value?: VaultReporting20250505SecretsInventoryRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'secret_name': value['secretName'],
        'secret_type': value['secretType'],
        'namespace': value['namespace'],
        'mount_path': value['mountPath'],
        'mount_accessor': value['mountAccessor'],
        'plugin_name': value['pluginName'],
        'plugin_type': value['pluginType'],
        'plugin_version': value['pluginVersion'],
        'version_count': value['versionCount'],
        'version_current': value['versionCurrent'],
        'version_oldest': value['versionOldest'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'created_by_id': value['createdById'],
        'config_last_modified_at': value['configLastModifiedAt'] == null ? undefined : ((value['configLastModifiedAt']).toISOString()),
        'config_last_modified_by_id': value['configLastModifiedById'],
        'config_last_accessed_at': value['configLastAccessedAt'] == null ? undefined : ((value['configLastAccessedAt']).toISOString()),
        'config_last_accessed_by_id': value['configLastAccessedById'],
        'config_deleted_at': value['configDeletedAt'] == null ? undefined : ((value['configDeletedAt']).toISOString()),
        'config_deleted_by_id': value['configDeletedById'],
        'secret_last_modified_at': value['secretLastModifiedAt'] == null ? undefined : ((value['secretLastModifiedAt']).toISOString()),
        'secret_last_modified_by_id': value['secretLastModifiedById'],
        'secret_last_accessed_at': value['secretLastAccessedAt'] == null ? undefined : ((value['secretLastAccessedAt']).toISOString()),
        'secret_last_accessed_by_id': value['secretLastAccessedById'],
        'secret_deleted_at': value['secretDeletedAt'] == null ? undefined : ((value['secretDeletedAt']).toISOString()),
        'secret_deleted_by_id': value['secretDeletedById'],
        'secret_undeleted_at': value['secretUndeletedAt'] == null ? undefined : ((value['secretUndeletedAt']).toISOString()),
        'secret_undeleted_by_id': value['secretUndeletedById'],
        'secret_destroyed_at': value['secretDestroyedAt'] == null ? undefined : ((value['secretDestroyedAt']).toISOString()),
        'secret_destroyed_by_id': value['secretDestroyedById'],
        'next_rotation_at': value['nextRotationAt'] == null ? undefined : ((value['nextRotationAt']).toISOString()),
        'ttl': value['ttl'],
    };
}

